// extracted by mini-css-extract-plugin
module.exports = {"container":"RenderLastSearch_container__NjMVi","container-hover":"RenderLastSearch_container-hover__Mzo6q"};